import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { ref: "onBoardingSaveDesignRef" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "btn-icon",
  width: "100%",
  height: "100%",
  viewBox: "0 0 33 33",
  version: "1.1",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}
}, [
  /*#__PURE__*/_createElementVNode("g", { transform: "matrix(2.0625,0,0,2.0625,1.77636e-15,8.88178e-16)" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M12.308,0L16,3.692L16,16L0,16L0,0L12.308,0ZM9.846,1.231L7.385,1.231L7.385,4.923L9.846,4.923L9.846,1.231ZM6.154,1.231L3.692,1.231L3.692,4.923L6.154,4.923L6.154,1.231ZM12.308,14.769L12.308,9.846L3.692,9.846L3.692,14.769L12.308,14.769ZM13.539,14.769L14.77,14.769L14.77,4.923L11.077,1.231L11.077,6.154L2.462,6.154L2.462,1.231L1.231,1.231L1.231,14.769L2.462,14.769L2.462,8.615L13.538,8.615L13.539,14.769Z" })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Save", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      "aria-label": "Open save label modal",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.isUserLoggedIn && _ctx.isUserLoggedIn(...args))),
      class: "btn save"
    }, _hoisted_4)
  ], 512))
}